import React, { useState }  from 'react'
import { Container, Row, Col, Card, Button, Collapse, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import redArrow from '../assets/images/red-arrow.svg'

function FAQ() {
  const [expandedCards, setExpandedCards] = useState({
    markets: false,
    apartments: false,
    resources: false,
    listings: false
  });

  const toggleCard = (card) => {
    setExpandedCards(prev => ({
      ...prev,
      [card]: !prev[card]
    }));
  };

  const cities = [
    ['Albuquerque', 'Aurora', 'Bend', 'Bowie', 'Charleston'],
    ['Alexandria', 'Austin', 'Birmingham', 'Brentwood', 'Charlotte'],
    ['Anchorage', 'Bakersfield', 'Boca Raton', 'Buffalo', 'Chattanooga'],
    ['Arlington', 'Baltimore', 'Boise real', 'Burlington', 'Chicago'],
    ['Ashburn', 'Baton Rouge', 'Boston', 'Cape Coral', 'Cincinnati'],
    ['Atlanta', 'Beaverton', 'Boulder', 'Chandler', 'Colorado Springs']
  ];

  const states = [
    ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California'],
    ['Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia'],
    ['Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa'],
    ['Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland']
  ];

  const markets = ['Fresno, CA', 'Los Angeles, CA', 'San Diego, CA', 'San Francisco, CA', 'Sacramento, CA'];
  const apartmentCities = ['New York, NY', 'Chicago, IL', 'Los Angeles, CA', 'Houston, TX', 'Phoenix, AZ'];
  const resources = ['Home Buying Guide', 'Mortgage Calculator', 'Market Trends', 'Property Values', 'School Ratings'];
  const newListings = ['California', 'Texas', 'Florida', 'New York', 'Arizona'];

  return (
    <>
     <div className="explore-result-locations common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>
           Frequently asked questions
          </h2>
          <p>
            With over a million agents from all the top brokerages, a local agent knows your market and can guide you through the process from start to finish
          </p>
        </div>
        <Accordion defaultActiveKey="0" >
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h5>How to find a good real estate agent near me?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              <h5>How to contact a real estate agent?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              <h5>How do I leave a review for a real estate agent?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="3">
            <Accordion.Header>
              <h5>What is the difference between an agent and a broker?</h5>
            </Accordion.Header>
            <Accordion.Body>
              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Container>
     </div>
    </>
  )
}
export default FAQ